<template>
  <div class="Weapons h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="weapon"
      :options="options"
      :options2="options2"
      :func1="this.links"
      :func2="this.type"
      filter1="Links"
      filter2="Category"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Two-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Weapons",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "linkCount",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "5", value: "5", disabled: false },
        { text: "6", value: "6", disabled: false },
      ],
      options2: [
        { text: "All", value: "All", disabled: false },
        { text: "1Hand Swords", value: "onehandswords", disabled: false },
        { text: "1Hand Maces", value: "onehandmaces", disabled: false },
        { text: "1Hand Axes", value: "onehandaxes", disabled: false },
        { text: "Claws", value: "claws", disabled: false },
        { text: "Daggers", value: "daggers", disabled: false },
        { text: "Bows", value: "bows", disabled: false },
        { text: "Wands", value: "wands", disabled: false },
        { text: "Scepters", value: "scepters", disabled: false },
        { text: "Staves", value: "staves", disabled: false },
        { text: "2Hand Swords", value: "twohandswords", disabled: false },
        { text: "2Hand Maces", value: "twohandmaces", disabled: false },
        { text: "2Hand Axes", value: "twohandaxes", disabled: false },
      ],
    };
  },
  mounted() {},

  computed: {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"name":"${item.name}","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"socket_filters":{"filters":{"links":{"r":null,"g":null,"b":null,"w":null,"a":null,"d":null,"min":${item.linkCount},"max":${item.linkCount}}},"disabled":false}}},"sort":{"price":"asc"}}`;
      }
    },
    links(val, item) {
      if (item.linkCount == val) {
        return true;
      }
      return false;
    },
    type(val, item) {
      if (item.group == val) {
        return true;
      }
      return false;
    },
  },
};
</script>
